import type { HTMLProps } from "react";

import { CheckIcon } from "@lucide/icons";

import { styled } from "simplydo/react/styled";
import { Icon } from "simplydo/react/ui/icon";

const StyledCheckbox = styled.div<{
  $compact?: boolean;
  $isSelected?: boolean;
}>`
  display: flex;
  width: ${({ $compact }) => ($compact ? "30px" : "40px")};
  height: ${({ $compact }) => ($compact ? "30px" : "40px")};
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  background-color: ${({ $isSelected, theme }) =>
    $isSelected ? theme.accent : "#e9ebee"};
  color: ${({ $isSelected }) => ($isSelected ? "#fff" : "gray")};
  padding: 5px;

  cursor: pointer;
  > ${Icon} {
    font-size: ${({ $compact }) => ($compact ? "1.2em" : "2em")};
    width: 1em;
    margin: 0;
  }
`;

type CheckboxProps = HTMLProps<HTMLDivElement> & {
  compact?: boolean;
  isSelected?: boolean;
};

const Checkbox = ({
  compact,
  isSelected,
  onClick,
  className,
}: CheckboxProps) => {
  return (
    <StyledCheckbox
      $compact={compact}
      $isSelected={isSelected}
      onClick={onClick}
      className={className}
    >
      <Icon icon={CheckIcon} className="icon-checkbox" />
    </StyledCheckbox>
  );
};

export default Checkbox;
